import React, { useState, useEffect } from 'react';
import Login from './pages/Login';
import StudentFlow from './pages/StudentFlow';
import AdminDashboard from './pages/AdminDashboard';
import AdminPanel from './pages/AdminPanel';

const API_URL = 'https://leertool.platform-psychoanalyse.nl';

function App() {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));

  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }
  }, []);

  const handleLogin = (userData, tokenData) => {
    setUser(userData);
    setToken(tokenData);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', tokenData);
  };

  const handleLogout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  if (!user) {
    return <Login onLogin={handleLogin} apiUrl={API_URL} />;
  }
  
  if (user.role === 'admin') {
    return <AdminPanel user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
  }

  if (user.role === 'teacher') {
    return <AdminDashboard user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
  }

  return <StudentFlow user={user} token={token} onLogout={handleLogout} apiUrl={API_URL} />;
}

export default App;
